import useragent from '@finance/useragent'


import ssjShare from './src/share-in-ssj'
import knShare from './src/share-in-kn'
import wxShare from './src/share-in-wx'
import h5Share from './src/share-in-h5'
import { shareResolve, shareReject } from './src/type'

export {
  setWechatShare
} from './src/share-in-wx'

interface IShareExecutor {
  (title: string, content: string, url: string): Promise<shareResolve | shareReject>
}

/**
 * (alias) const ssjShare: (title: any, content: any, url: any) => Promise<any>
 * @param {string} title - 分享标题
 * @param {string} content - 分享副标题
 * @param {string} url - 分享连接
 *
 * @return in then - type = 'h5' | 'pyq' | 'qq' | 'qzone' | 'weixin' | 'message' | 'link' | 'sina_weibo'
 * @return in catch - 分享连接 ['cancel' | 'error', type]
 */
const shareExecutor: IShareExecutor = (() => {
  if (useragent.isSuishouji) {
    return ssjShare
  }
  if (useragent.isKaniu) {
    return knShare
  }
  if (useragent.isWechat) {
    return wxShare
  }
  return h5Share
})()

export default shareExecutor
